webpackJsonp([1],{

/***/ 22:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var navigator = window.navigator;
navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
var AudioContext = window.AudioContext || window.webkitAudioContext;

var isSupport = !!(navigator.getUserMedia && AudioContext);
var context = isSupport && new AudioContext();
/* harmony default export */ __webpack_exports__["a"] = ({
  isSupport: isSupport,
  start: function start() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      navigator.getUserMedia({ audio: true }, function (stream) {
        var source = context.createMediaStreamSource(stream);
        var analyser = context.createAnalyser();
        source.connect(analyser);
        analyser.fftSize = 2048;
        resolve(analyser);
      }, function () {
        reject();
      });
    });
  },
  getVoiceSize: function getVoiceSize(analyser) {
    var dataArray = new Uint8Array(analyser.frequencyBinCount);
    analyser.getByteFrequencyData(dataArray);
    var data = dataArray.slice(100, 1000);
    var sum = data.reduce(function (a, b) {
      return a + b;
    });
    return sum;
  }
});

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(79)

var Component = __webpack_require__(37)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(85),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var dataArray = [{
  height: '50%',
  width: '900px',
  marginLeft: 0
}];
for (var i = 0; i < 50; i++) {
  var random = parseInt(Math.random() * 1000);
  var height = (random % 3 + 3) * 10;
  var width = (random % 5 + 2) * 40;
  var marginLeft = (random % 2 + 1.5) * 40;
  dataArray.push({
    height: height + '%',
    width: width + 'px',
    marginLeft: (marginLeft < 70 ? 70 : marginLeft) + 'px'
  });
}
/* harmony default export */ __webpack_exports__["a"] = (dataArray);

/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);




new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 42:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_AudioAPI__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Game__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Game___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Game__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: { Game: __WEBPACK_IMPORTED_MODULE_1__components_Game___default.a },
  data: function data() {
    return {
      isSupport: __WEBPACK_IMPORTED_MODULE_0__js_AudioAPI__["a" /* default */].isSupport,
      timer: '',
      game: {
        voice: 0
      }
    };
  }
});

/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_AudioAPI__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__game_data__ = __webpack_require__(40);




var analyser = void 0;

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      timer: '',
      isStart: false,
      isStop: false,
      voiceSize: 0,
      sensitivity: 1000,
      blocks: __WEBPACK_IMPORTED_MODULE_1__game_data__["a" /* default */],
      blockPosition: 0,
      currentNodeIndex: 0,
      playerBottom: 300,
      autoDown: false,
      jumpTimes: 0,
      showPlayer: false,
      imgType: 1,
      startTime: new Date(),
      currentTime: new Date(),
      flushGameTime: '',
      gameOverOpacity: 0
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function (_) {
      _this.showPlayer = true;
      _this.$watch('voice', function (val) {
        if (_this.inBlock) {
          _this.imgType = val % 2 + 1;
        } else {
          _this.imgType = val % 2 + 4;
        }
      });
    });
  },

  computed: {
    voice: function voice() {
      return parseInt(this.voiceSize / this.sensitivity);
    },
    currentNode: function currentNode() {
      return this.$refs.gameWrapper.childNodes[this.currentNodeIndex];
    },
    nodeStartPosition: function nodeStartPosition() {
      return this.currentNode.offsetLeft;
    },
    nodeEndPosition: function nodeEndPosition() {
      return this.nodeStartPosition + this.currentNode.offsetWidth;
    },
    playerEL: function playerEL() {
      return this.$refs.player;
    },
    playerStartPosition: function playerStartPosition() {
      return this.playerEL.offsetLeft + this.blockPosition;
    },
    playerEndPosition: function playerEndPosition() {
      return this.playerStartPosition + this.playerEL.clientWidth;
    },
    currentNodeHeight: function currentNodeHeight() {
      return this.currentNode.clientHeight;
    },
    onBlock: function onBlock() {
      if (this.playerStartPosition < this.nodeEndPosition && this.playerEndPosition > this.nodeStartPosition) {
        return true;
      }
      return false;
    },
    inBlock: function inBlock() {
      return this.onBlock && this.playerBottom === this.currentNodeHeight;
    }
  },
  watch: {
    playerBottom: function playerBottom(val) {
      if (val <= -50) {
        this.gameOver();
      }
    }
  },
  methods: {
    start: function start() {
      var _this2 = this;

      if (!analyser) {
        __WEBPACK_IMPORTED_MODULE_0__js_AudioAPI__["a" /* default */].start().then(function (a) {
          analyser = a;
          _this2.gameStart();
        });
      } else {
        this.gameStart();
      }
      this.isStart = true;
      this.isStop = false;
      this.startTime = new Date();
      this.flushGameTime = setInterval(function () {
        _this2.currentTime = new Date();
      }, 20);
      this.$nextTick(function () {
        _this2.currentNodeChanged();
      });
    },
    stop: function stop() {
      this.isStop = true;
      this.stopGetVoiceSize();
      this.stopAutoDown();
      clearInterval(this.flushGameTime);
    },
    gameOver: function gameOver() {
      var _this3 = this;

      this.gameOverOpacity = 1;
      setTimeout(function () {
        _this3.gameOverOpacity = 0;
        _this3.back();
      }, 1200);
    },
    back: function back() {
      this.stopGetVoiceSize();
      this.stopAutoDown();
      this.isStart = false;
      this.blockPosition = 0;
      this.currentNodeIndex = 0;
      this.playerBottom = this.$refs.gameWrapper.childNodes[this.currentNodeIndex].clientHeight;
    },
    gameStart: function gameStart() {
      this.startGetVoiceSize();
      this.playerAutoDown();
    },
    startGetVoiceSize: function startGetVoiceSize() {
      var _this4 = this;

      this.timer = setTimeout(function () {
        var voiceSize = __WEBPACK_IMPORTED_MODULE_0__js_AudioAPI__["a" /* default */].getVoiceSize(analyser);
        _this4.voiceSize = voiceSize;
        _this4.voiceChanged();
        _this4.startGetVoiceSize();
      }, 5);
    },
    currentNodeChanged: function currentNodeChanged() {
      if (this.playerStartPosition > this.nodeEndPosition) {
        this.currentNodeIndex++;
      }
      if (!this.onBlock && this.playerBottom < this.currentNodeHeight && this.playerEndPosition >= this.nodeStartPosition) {
        this.blockPosition--;
      }
    },
    stopAutoDown: function stopAutoDown() {
      clearInterval(this.autoDown);
      this.autoDown = '';
    },
    playerAutoDown: function playerAutoDown() {
      var _this5 = this;

      if (!this.autoDown) {
        this.autoDown = setInterval(function () {
          if (_this5.onBlock && _this5.playerBottom <= _this5.currentNodeHeight) {
            _this5.playerBottom = _this5.currentNodeHeight;
          } else {
            _this5.playerBottom -= 1;
          }
        }, 10);
      }
    },
    jumpPlayer: function jumpPlayer(height) {
      this.stopAutoDown();
      this.playerBottom += height;
      if (this.jumpTimes > 10) {
        this.jumpTimes = 0;
        this.playerAutoDown();
      } else {
        this.jumpTimes++;
      }
    },
    voiceChanged: function voiceChanged() {
      if (this.voice > 3) {
        this.blockPosition++;
        this.currentNodeChanged();
        if (this.inBlock && this.voice > 40 || this.jumpTimes) {
          this.jumpPlayer(parseInt(this.voice / 5));
        }
      }
    },
    stopGetVoiceSize: function stopGetVoiceSize() {
      clearTimeout(this.timer);
    }
  }
});

/***/ }),

/***/ 79:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 80:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(80)

var Component = __webpack_require__(37)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(86),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 85:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_vm._m(0), (_vm.isSupport) ? _c('div', {
    staticClass: "app-container"
  }, [_c('game')], 1) : _c('div', {
    staticClass: "not-support"
  }, [_vm._v("暂不支持此浏览器，请用谷歌浏览器打开此链接"), _c('a', {
    attrs: {
      "href": "http://www.google.cn/chrome/browser/desktop/index.html",
      "target": "_blank"
    }
  }, [_vm._v("谷歌浏览器下载地址")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://github.com/k55k32/quaver",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "right": "0",
      "border": "0"
    },
    attrs: {
      "src": "https://camo.githubusercontent.com/38ef81f8aca64bb9a64448d0d70f1308ef5341ab/68747470733a2f2f73332e616d617a6f6e6177732e636f6d2f6769746875622f726962626f6e732f666f726b6d655f72696768745f6461726b626c75655f3132313632312e706e67",
      "alt": "Fork me on GitHub",
      "data-canonical-src": "https://s3.amazonaws.com/github/ribbons/forkme_right_darkblue_121621.png"
    }
  })])
}]}

/***/ }),

/***/ 86:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isStart),
      expression: "isStart"
    }],
    staticClass: "game-container"
  }, [_c('div', {
    ref: "player",
    staticClass: "player",
    style: ({
      bottom: (_vm.playerBottom + "px")
    })
  }, [_c('img', {
    attrs: {
      "src": ("/static/img/" + _vm.imgType + ".png")
    }
  })]), _c('div', {
    staticClass: "game-main-window"
  }, [_c('div', {
    ref: "gameWrapper",
    staticClass: "game-wrapper",
    style: ({
      transform: ("translate(" + (-_vm.blockPosition) + "px, 0)")
    })
  }, _vm._l((_vm.blocks), function(b) {
    return _c('div', {
      staticClass: "block",
      style: (b)
    })
  }))]), _c('div', {
    staticClass: "notice"
  }, [_c('div', {
    staticClass: "time"
  }, [_vm._v("TIMES: " + _vm._s((_vm.currentTime.getTime() - _vm.startTime.getTime()) / 1000))])]), _c('div', {
    staticClass: "stop"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("BACK")])]), _c('div', {
    staticClass: "over-mask",
    style: ({
      opacity: _vm.gameOverOpacity
    })
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isStart),
      expression: "!isStart"
    }],
    staticClass: "game-container"
  }, [_c('h1', {
    staticClass: "desc"
  }, [_vm._v("八分音符 HTML5 版本")]), _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.start
    }
  }, [_vm._v("开始游戏")])])])
},staticRenderFns: []}

/***/ })

},[41]);


// WEBPACK FOOTER //
// static/js/app.d9e440a5b0fbd85acd9a.js